import { useEffect } from 'react'
import { useTheme } from '../../contexts/ThemeContext'

export const Favicon: React.FC = () => {
  const { resolvedTheme } = useTheme()

  useEffect(() => {
    // Update favicon based on theme
    const link = document.querySelector("link[rel~='icon']") as HTMLLinkElement
    if (link) {
      // Use icon-green.png for light mode, icon-white.png for dark mode
      // Fallback to icon.png if theme-specific icons don't exist
      const iconSrc = resolvedTheme === 'dark' ? '/icon-white.png' : '/icon-green.png'
      link.href = iconSrc
      
      // Also update shortcut icon
      const shortcutLink = document.querySelector("link[rel~='shortcut icon']") as HTMLLinkElement
      if (shortcutLink) {
        shortcutLink.href = iconSrc
      }
    }
  }, [resolvedTheme])

  return null
}

